import React from "react";
import { SERENITY_DEGREE_STROKES, SERENITY_TONIC_FILL } from "../../lib/scaleModuleTheme";

export interface ExploreDegreeItem {
  degree: string;
  note?: string;
}

export interface ExploreDegreeLegendProps {
  degrees: readonly ExploreDegreeItem[];
  onDegreeClick?: (degree: string) => void;
  /** Barra inferior de transporte */
  compact?: boolean;
}

/** Leyenda horizontal de grados (Serenity). */
export const ExploreDegreeLegend: React.FC<ExploreDegreeLegendProps> = ({
  degrees,
  onDegreeClick,
  compact = false,
}) => (
  <div
    className={`flex flex-row flex-wrap items-center font-sans uppercase text-white/50 ${
      compact
        ? "gap-x-4 gap-y-1 text-[10px] tracking-[0.12em]"
        : "gap-x-6 gap-y-2 text-sm tracking-widest"
    }`}
  >
    {degrees.map(({ degree }, idx) => {
      const isTonic = idx === 0 || degree === "R";
      const stroke = SERENITY_DEGREE_STROKES[idx % 7];
      return (
        <button
          key={`${degree}-${idx}`}
          type="button"
          onClick={() => onDegreeClick?.(degree)}
          className="flex items-center gap-2 hover:text-white/75 transition-colors"
        >
          <span
            className={`rounded-full shrink-0 border ${compact ? "w-2.5 h-2.5" : "w-3 h-3"}`}
            style={
              isTonic
                ? {
                    backgroundColor: SERENITY_TONIC_FILL,
                    borderColor: "rgba(255,255,255,0.45)",
                    boxShadow: "0 0 4px rgba(248,113,113,0.45)",
                  }
                : {
                    backgroundColor: "rgba(255,255,255,0.08)",
                    borderColor: stroke,
                  }
            }
          />
          {degree}
        </button>
      );
    })}
  </div>
);
